export default __webpack_public_path__ + "static/media/gallery_15.ec78e5b7.jpg";